<template>
  <v-col cols="12">
    <v-col cols="12">
      <v-card
        class="rounded-0 pa-7"
        elevation="0"
        style="border: 12px solid #095797 !important "
      >
        <v-card-title class="titreBoite">
          {{$t('accueil.BoiteResultatsEleves.ResultatScolaire')}}
        </v-card-title>

        <v-card-text
          class="texteBoite grisFonce"
          v-html="appStore.texteDynamique.BlocTexte21"
        >
        </v-card-text>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  name: 'BoiteResultatsEleves',
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  data() {
    return {
    };
  },
  created() {
  },
};
</script>
